module.exports = __webpack_public_path__ + "img/104.20b44057.svg";